<div class="row h-100 align-items-center">
  <!-- <div class="col-12 fontwhite p-50">
    <h2>
      Hi, Welcome
    </h2>
    <p class="paraFont">
      An end-to-end, transparent transactional platform where origin, quality, safety and traceability are critical
      to the public, regulators and financial institutions.
    </p>
  </div>
</div>
<div class="copyright pos-abs text-center">
  <p class="mb-4 fontwhite">
    © 2020 StandardC. All Rights Reserved
  </p>
</div> -->
<div class="copyright pos-abs text-center">
  <p class=" fontwhite">
    <!-- © {{year}} StandardC, Inc. All Rights Reserved -->
  </p>
</div> 
<div class="yellow_square">
</div>
</div>